var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":_vm.nullBg,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"no-data-tip"},[_c('span',[_vm._v("暂无数据")]),_vm._v(" "),(_vm.link)?_c('a',{staticClass:"highlight",attrs:{"href":_vm.link,"target":_vm.link}},[_vm._v(","+_vm._s(_vm.msg))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c86c7714","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoData.vue
// module id = null
// module chunks = 